import React from "react";
import ReactFullpage from "@fullpage/react-fullpage";
import HomeSection from "../pages/home/home";
import ContactSection from "../pages/contact/ContactSection/ContactSection";
import AboutSection from "../pages/about/AboutSection/AboutSection";
import PartnerSection from "../pages/partners/PartnerSection/PartnerSection";
import Projects from "../pages/projects/Projects/Projects";
import ArtParkDetails from "../pages/artDetails/ArtParkDetails/ArtParkDetails";
import CareerSection from "../pages/career/CareerSection/CareerSection";
import TeamSection from "../pages/team/TeamSection/TeamSection";
import NewsSection from "../pages/news/NewsSection/NewsSection";
import Emitter from "../utils/emitter";
import AcademicInitiatives from "../pages/academic/AcademicInitiatives/AcademicInitiatives";
import OurChart from "../pages/ourtChart/OurChart";
const pluginWrapper = () => {
  require('../assets/js/fullpage.scrollOverflowReset.min');
};

class FullpageWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fapi: null, run: 0, section: null, avoidScroll: '.modal' };
  }

  trackPos = (data) => {
    this.setState({
      position: { x: 0, y: data.y }
    })
    // let pos = data.y / switcher;
  };

  componentDidMount() {
    Emitter.on("MOVE_DOWN", (newValue) => this.moveDown());
    Emitter.on("MOVE_SECTION", (newValue) => this.moveSection(newValue));
    // console.re.log("Screen height : " + window.screen.height)
    if (window.innerWidth > 600) {
      this.setState({ avoidScroll: '.modal, .inno-fellow-container, .maxhsx' })
    }
    setTimeout(() => {
      // console.re.log(this.state.avoidScroll);
      // console.re.log("REBUILDING FULLPAGE");
      window.fullpage_api.reBuild()
    }, 2500);
  }


  afterLoad(origin, destination, direction) {
    window.fullpage_api.reBuild()
    this.setState({ section: destination.index })
    //console.re.log("After load: " + destination.index);
    if (
      destination.index === 1 ||
      destination.index === 0 ||
      this.state.run == 0
    ) {
      this.setState({
        run: 1,
      });
      Emitter.emit("SECTION_SCROLLED", destination.index);
    }
  }
  moveDown() {
    window.fullpage_api.moveSectionDown();
  }
  moveSection(value) {
    Emitter.emit("SECTION_SCROLLED", 1);
    window.fullpage_api.silentMoveTo(value);
  }


  render() {

    return (
      <ReactFullpage
        pluginWrapper={pluginWrapper}
        licenseKey={'D6289CAE-F74E4FAB-80923DCA-3396F20F'}
        anchors={[
          "home",
          "about-us",
          "partners",
          "chart",
          "projects",
          "Startup-@-ARTPARK",
          "Academic",
          "teams",
          "news",
          "career",
          "contact",
          "footer",

        ]}
        scrollOverflow={true}
        scrollOverflowResetKey="YXJ0cGFyay5pbl9oR2xjMk55YjJ4c1QzWmxjbVpzYjNkU1pYTmxkQT09RU92"
        scrollOverflowReset={true}
        normalScrollElements={this.state.avoidScroll}
        afterLoad={this.afterLoad.bind(this)}
        render={({ state, fullpageApi }) => {
          return (
            <div id="fullpage-wrapper p-0 m-0">
              <div id="homes" className="section p-0 m-0">
                <HomeSection sectionNo={this.state.section}></HomeSection>
              </div>
              <div id="abouts" className="section p-0 m-0 ">
                <AboutSection></AboutSection>
              </div>
              <div id="partner" className="section ">
                <PartnerSection></PartnerSection>
              </div>
              <div className="section" id="charter">
                <OurChart></OurChart>
              </div>
              <div id="project" className="section ">
                <Projects></Projects>
              </div>

              <div id="art-details" className="section ">
                <ArtParkDetails></ArtParkDetails>
              </div>
              <div id="academicss" className="section ">
                <AcademicInitiatives></AcademicInitiatives>
              </div>
              <div id="teamdet" className="section ">
                <TeamSection></TeamSection>
              </div>
              <div id="newss" className="section ">
                <NewsSection></NewsSection>
              </div>
              <div id="careers" className="section ">
                <CareerSection></CareerSection>
              </div>
              <div id="contacts" className="section ">
                <ContactSection></ContactSection>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

export default FullpageWrapper;
